import { RepresentantiveDocument } from 'components/molecules/Representative/RepresentativeDocument';
import { IRepresentantFile } from 'types/Representant';

import { Grid } from '@mui/material';

type Props = {
  idRepresentant?: string;
  documents: IRepresentantFile[] | null;
};

export const RepresentativeDocuments: React.FC<Props> = ({
  idRepresentant,
  documents,
}) => {
  if (!documents) {
    return null;
  }

  return (
    <Grid container item spacing={1}>
      {documents.map((document) => (
        <RepresentantiveDocument
          key={document._id ?? document.file?.name}
          document={document}
          representantiveId={idRepresentant}
        />
      ))}
    </Grid>
  );
};

